export default function Specifications({ title, list }) {
    return (
        <div className="w-full align-top border-t-2 border-white text-left">
            <div className="uppercase p-4 font-bold border-b-2 border-white ">{title}</div>
            {list.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {list.map((d) => (
                        <div
                            key={d.id.toString()}
                            className="py-2 px-4 border-b border-white border-opacity-10 "
                        >
                            {d.Key}
                            {d.Value && (
                                <>
                                    : <strong className="font-semibold">{d.Value}</strong>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
